import toast from "@/services/Notification";
import HTTP from "@/_helpers/http";
import { TICKETS__MUTATIONS } from "../mutation-types";
import { TICKETS__ACTIONS } from "../action-types";
import { TICKETS__API } from "@/_helpers/urls";

const state = {
  tickets: [],
  totalTickets: 0,
  ticketDetails: {},
};

const mutations = {
  [TICKETS__MUTATIONS.SET_TICKETS](state, value) {
    state.tickets = value;
  },
  [TICKETS__MUTATIONS.SET_TOTAL_TICKETS](state, value) {
    state.totalTickets = value;
  },
  [TICKETS__MUTATIONS.SET_TICKET_DETAILS](state, value) {
    state.ticketDetails = value;
  },
  [TICKETS__MUTATIONS.RESET_TICKET](state) {
    state.ticketDetails = {};
  }
};

const actions = {
  async [TICKETS__ACTIONS.TICKETS]({ commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(TICKETS__API.ALLTICKETS);
      if (response?.data?.tickets) {
        commit(TICKETS__MUTATIONS.SET_TICKETS, response.data.tickets);
        commit(TICKETS__MUTATIONS.SET_TOTAL_TICKETS, response.data.totalTickets || 0);
      }
    } catch (error) {
      console.error('Error fetching tickets:', error);
      toast.error('Failed to fetch tickets');
    }
  },

  async [TICKETS__ACTIONS.DETAILS]({ commit }, id) {
    if (!id) return;

    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).get(`${TICKETS__API.DETAILSWITHCOMMENTS}/${id}`);
      if (response?.data?.ticket) {
        commit(TICKETS__MUTATIONS.SET_TICKET_DETAILS, response.data.ticket);
      }
    } catch (error) {
      console.error('Error fetching ticket details:', error);
      toast.error('Failed to fetch ticket details');
    }
  },

  async [TICKETS__ACTIONS.CREATE]({ commit, dispatch }, data) {
    if (!data?.subject || !data?.description) {
      toast.error('Subject and description are required');
      return;
    }

    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: 'Processing...'
      }).post(TICKETS__API.CREATE, {
        subject: data.subject,
        description: data.description,
      });

      if (response?.data?.message) {
        toast.success(response.data.message);
        await dispatch(TICKETS__ACTIONS.TICKETS);
        commit(TICKETS__MUTATIONS.RESET_TICKET);
      }
    } catch (error) {
      console.error('Error creating ticket:', error);
      const errorMessage = error.response?.data?.message || 'Failed to create ticket';
      toast.error(errorMessage);
      throw error;
    }
  },

  // async [TICKETS__ACTIONS.REPLY]({ dispatch }, data) {
  //   if (!data?.id || !data?.comment) {
  //     toast.error('Ticket ID and comment are required');
  //     return;
  //   }

  //   try {
  //     const response = await HTTP({
  //       trackProgress: true,
  //       loadingText: 'Processing...'
  //     }).post(TICKETS__API.REPLY, {
  //       client_ticket_id: data.id,
  //       comment: data.comment,
  //     });

  //     if (response?.data) {
  //       await dispatch(TICKETS__ACTIONS.DETAILS, data.id);
  //     }
  //   } catch (error) {
  //     console.error('Error replying to ticket:', error);
  //     toast.error(error.response?.data?.message || 'Failed to send reply');
  //   }
  // },

 async [TICKETS__ACTIONS.REPLY]({ dispatch }, data) {
  if (!data?.id || (!data?.comment && !data?.file)) {
    toast.error('Ticket ID and comment or file are required>>>>>>');
    return;
  }

  const formData = new FormData();
  formData.append("client_ticket_id", data.id);
  formData.append("comment", data.comment || "");
  if (data.file) formData.append("file", data.file);

  await HTTP().post(TICKETS__API.REPLY, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });

  await dispatch(TICKETS__ACTIONS.DETAILS, data.id);
}




};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters: {},
  mutations,
  actions,
};